function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MoldovaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2638",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2638)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 3H24V21H16.5V3Z",
      fill: "#D9071E"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H9V21H0V3Z",
      fill: "#3D58DB"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3H16.5V21H7.5V3Z",
      fill: "#FBCD17"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.2888 17.7106L15.499 18.1421L12.8811 13.3506L13.6709 12.919L16.2888 17.7106ZM7.88507 17.8258L8.67488 18.2573L11.2928 13.4658L10.503 13.0342L7.88507 17.8258Z",
      fill: "#FD1900"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.53358 10.0418V14.2053C8.53358 15.1302 7.73719 16.3355 7.33554 16.7839C6.93389 17.2323 6.13617 18.2597 6.13617 18.2597V7.05624C6.13617 5.79957 7.33554 5.36788 7.33554 5.36788C7.33554 5.36788 8.3314 5.5649 8.53358 7.05624V8.50972C8.84182 8.75246 9.87108 9.49689 10.536 9.18264C11.3255 8.80951 11.5981 7.73929 11.5981 7.73929C11.5981 7.73929 11.5243 6.65937 11.2003 6.65937C10.8762 6.65937 10.8503 5.13817 12.0913 5.13817C13.3323 5.13817 13.4769 5.72453 13.4769 6.19195C13.4769 6.43697 13.2805 6.83019 13.0936 7.20438C12.924 7.54404 12.7621 7.86802 12.7621 8.05126C12.7621 8.43638 13.0523 9.18264 13.4769 9.18264C13.7747 9.18264 15.2071 8.62613 16.0362 8.29373V7.05624C16.2383 5.5649 17.2342 5.36788 17.2342 5.36788C17.2342 5.36788 18.4336 5.79957 18.4336 7.05624V18.2597C18.4336 18.2597 17.6359 17.2323 17.2342 16.7839C16.8326 16.3355 16.0362 15.1302 16.0362 14.2053V10.0418H8.53358ZM9.86267 17.8741C10.6739 17.346 11.8605 14.9776 11.8605 14.9776L12.2545 15.0691C12.2545 15.0691 12.856 16.6379 14.6248 17.8741C12.7394 18.3773 12.2545 19.3876 12.2545 19.3876C12.2545 18.5794 9.86267 17.8741 9.86267 17.8741ZM9.73203 16.375C10.2788 16.375 10.722 15.9553 10.722 15.4375C10.722 14.9197 10.2788 14.5 9.73203 14.5C9.18527 14.5 8.74203 14.9197 8.74203 15.4375C8.74203 15.9553 9.18527 16.375 9.73203 16.375ZM15.54 15.4375C15.54 15.9553 15.0968 16.375 14.55 16.375C14.0033 16.375 13.56 15.9553 13.56 15.4375C13.56 14.9197 14.0033 14.5 14.55 14.5C15.0968 14.5 15.54 14.9197 15.54 15.4375Z",
      fill: "#A77B3B"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.855 10.8057L19.5434 11.1033L16.7387 17.5922L16.0503 17.2947L18.855 10.8057Z",
      fill: "#FDFF00"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.3",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.28003 8.875H16.2V14.6042C16.2 14.6042 14.1847 15.2112 12.24 16.2073C10.8045 15.1424 8.28003 14.6042 8.28003 14.6042V8.875Z",
      fill: "#E1E5E8"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2638",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "8",
      y: "8",
      width: "9",
      height: "9",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.28003 8.875H16.2V14.6042C16.2 14.6042 14.1847 15.2112 12.24 16.2073C10.8045 15.1424 8.28003 14.6042 8.28003 14.6042V8.875Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2638)",
      children: [/*#__PURE__*/_jsx("rect", {
        x: "8.28003",
        y: "12.625",
        width: "7.92",
        height: "3.75",
        fill: "#3D58DB"
      }), /*#__PURE__*/_jsx("rect", {
        x: "8.28003",
        y: "8.875",
        width: "7.92",
        height: "3.75",
        fill: "#FD1900"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.84 10.5616L11.2398 10.6113L11.586 10.1443L11.217 9.66064L11.8203 9.73833L12.0517 9.20502L12.3088 9.7497L12.909 9.70002L12.5628 10.167L12.9318 10.6506L12.3285 10.573L12.0971 11.1063L11.84 10.5616Z",
        fill: "#FDFF00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7625 9.50377C10.7625 9.50377 9.15011 10.4848 9.68759 11.189C10.2251 11.8932 10.9016 11.9833 10.9016 11.9833C10.9016 11.9833 9.25223 14.4578 12.1552 15.8715C15.2633 14.5068 13.6287 11.9833 13.6287 11.9833C13.6287 11.9833 14.5855 11.7717 14.777 11.0102C14.9686 10.2488 13.5265 9.3755 13.5265 9.3755C13.5265 9.3755 14.4262 10.6796 14.2208 11.0102C14.0154 11.3409 12.9151 11.6775 12.1552 11.6775C11.3954 11.6775 10.2221 11.4641 10.0328 10.8864C9.84341 10.3086 10.7625 9.50377 10.7625 9.50377Z",
        fill: "#FDFF00"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.55249 11.6467C3.55249 11.6467 4.34308 12.5814 5.08751 12.2758C5.83193 11.9702 5.65145 10.8746 5.65145 10.8746L5.08751 11.3862H4.60746V11.6467L4.23254 11.3862V11.6467H3.55249ZM4.08719 13.083C4.08719 13.083 5.05078 13.9234 5.69997 13.686C6.34917 13.4485 6.18615 12.3109 6.18615 12.3109L5.62221 12.8225H5.14216V13.083L4.76724 12.8225V13.083H4.08719ZM6.68203 14.9902C6.03284 15.2277 5.06925 14.3873 5.06925 14.3873H5.7493V14.1267L6.12422 14.3873V14.1267H6.60427L7.16821 13.6151C7.16821 13.6151 7.33123 14.7527 6.68203 14.9902Z",
      fill: "#048F02"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.4845 4.68637H9.73454V5.13306H9.38153V5.88306H9.73454V7.19153H10.4845V5.88306H10.9137V5.13306H10.4845V4.68637Z",
      fill: "#FDFF00"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.3686 5.53844L9.63147 5.98593L11.3686 6.53483V5.53844Z",
      fill: "#DB4400"
    })]
  })]
}));
//# sourceMappingURL=Moldova.js.map